const numbers = document.querySelectorAll(".number-animation");
const animationDuration = 800;
const initialAnimationDelay = 300;
let start, previousTimeStamp;

const elements = document.querySelectorAll(".scroll-animate");
let intViewportHeight = window.innerHeight;
const animateOffset = -50;

function step(timestamp) {
  if (start === undefined || start === 0) {
    start = timestamp;
  }
  const elapsed = timestamp - start;

  if (previousTimeStamp !== timestamp) {
    numbers.forEach(number => {
      if (
        number.dataset.scrollAnimate != "true" &&
        number.dataset.animated != "true"
      ) {
        let currentNum = parseInt(number.innerHTML);
        if (
          (animationDuration / (number.dataset.animation - 1)) * currentNum <=
          elapsed
        ) {
          currentNum++;
          number.innerHTML = currentNum;
          if (currentNum == number.dataset.animation) {
            number.dataset.animated = "true";
          }
        }
      }
    });
  }

  if (elapsed < animationDuration + 2000) {
    // Stop the animation after 2 seconds
    previousTimeStamp = timestamp;
    window.requestAnimationFrame(step);
  }
}

function scrollAnimate() {
  elements.forEach(element => {
    if (
      element.dataset.animated == "false" &&
      element.dataset.active != "true"
    ) {
      if (
        element.getBoundingClientRect().top - intViewportHeight <
        animateOffset
      ) {
        start = 0;
        window.requestAnimationFrame(step);
        element.dataset.active = "true";
        element.dataset.scrollAnimate = "false";
      }
    }
  });
}

setTimeout(() => {
  window.requestAnimationFrame(step);
}, initialAnimationDelay);

document.addEventListener("scroll", scrollAnimate);
scrollAnimate();
